import { IconProps } from "./";
import Icon from "./assets/check_outline_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24CheckOutline(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
